var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{on:{"click":function($event){$event.preventDefault();return _vm.$router.go(-1)}}},[_c('i',{staticClass:"fas fa-arrow-left mr-1"}),_vm._v(" "+_vm._s(_vm.$t('上一頁'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }